import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, MessageCircle } from 'lucide-react';
import { getWhatsAppUrl } from '../utils/whatsapp';
const faqs = [{
  q: '¿La depilación láser duele?',
  a: 'La tecnología Láser Soprano está diseñada para brindar una experiencia mucho más cómoda que otros métodos tradicionales. La mayoría de nuestros clientes describen la sensación como un leve calor sobre la piel.'
}, {
  q: '¿Cuántas sesiones necesito?',
  a: 'La cantidad de sesiones varía según la zona tratada, el tipo de piel y las características del vello. Generalmente se recomiendan entre 8 y 12 sesiones para obtener resultados óptimos.'
}, {
  q: '¿Cuándo voy a empezar a notar resultados?',
  a: 'Muchas personas comienzan a notar una reducción visible del vello desde las primeras sesiones. Los resultados continúan mejorando progresivamente a medida que avanza el tratamiento.'
}, {
  q: '¿Es seguro para todo tipo de piel?',
  a: 'Sí. La tecnología Láser Soprano está diseñada para trabajar de forma segura en distintos tipos de piel, siempre bajo una evaluación previa y seguimiento profesional.'
}, {
  q: '¿Cuánto dura cada sesión?',
  a: 'Depende de la zona a tratar. Algunas sesiones pueden durar apenas unos minutos, mientras que tratamientos en áreas más amplias requieren más tiempo.'
}, {
  q: '¿Pueden realizarse tratamientos en hombres y mujeres?',
  a: 'Sí. Realizamos tratamientos personalizados tanto para mujeres como para hombres en diferentes zonas del cuerpo.'
}, {
  q: '¿Qué debo hacer antes de mi sesión?',
  a: 'Antes de cada sesión se recomienda rasurar la zona a tratar y evitar la exposición solar intensa durante los días previos. Durante la evaluación inicial te brindaremos todas las indicaciones necesarias.'
}, {
  q: '¿La consulta inicial tiene costo?',
  a: 'No. Puedes solicitar una evaluación inicial para conocer el tratamiento recomendado, resolver tus dudas y recibir asesoramiento personalizado.'
}, {
  q: '¿Los resultados son permanentes?',
  a: 'La depilación láser logra una reducción progresiva y duradera del vello. Dependiendo de cada caso, pueden recomendarse sesiones de mantenimiento periódicas.'
}, {
  q: '¿Puedo reservar por WhatsApp?',
  a: 'Sí. Puedes comunicarte directamente por WhatsApp para consultar disponibilidad, resolver dudas y coordinar tu evaluación.'
}];
export const Faq = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-12 sm:py-20 bg-slate-50" id="faq" data-id="element-126">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-127">
        <div className="text-center max-w-2xl mx-auto mb-12" data-id="element-128">
          <h2 className="text-2xl sm:text-3xl font-bold text-navy-900 mb-4" data-id="element-129">
            Preguntas Frecuentes
          </h2>
          <p className="text-base sm:text-lg text-slate-600" data-id="element-130">
            Resolvemos las dudas más comunes sobre el tratamiento.
          </p>
        </div>

        <div className="space-y-3" data-id="element-131">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="bg-white rounded-2xl border border-slate-200 overflow-hidden" data-id="element-132">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between gap-4 text-left px-5 sm:px-6 py-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 rounded-2xl" aria-expanded={isOpen} data-id="element-133">
                  <span className="font-bold text-navy-900 text-base sm:text-lg" data-id="element-134">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-brand-600 shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-135" />
                </button>
                <AnimatePresence initial={false} data-id="element-136">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-137">
                      <p className="px-5 sm:px-6 pb-5 text-slate-600 leading-relaxed" data-id="element-138">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="mt-10 text-center" data-id="element-139">
          <p className="text-slate-600 mb-4" data-id="element-140">¿Tenés otra consulta?</p>
          <a href={getWhatsAppUrl('Hola! Tengo una consulta sobre el tratamiento de depilación láser.')} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[#25D366] text-white font-semibold px-6 py-3 rounded-full hover:bg-[#20bd5a] transition-colors" data-id="element-141">
            <MessageCircle className="w-5 h-5" data-id="element-142" />
            Escribinos por WhatsApp
          </a>
        </div>
      </div>
    </section>;
};